import { Component } from '@angular/core';
import { CustomModal } from '@workflow/dynamic-render/page/shared/core-custom-page.decorator';
import { UserService } from '@workflow/ecp-shared/service/user/user.service';
/**
 * custom modal to confirm user before leave the page.
 * the user response will be propagate to required place by observable
 */
@CustomModal('oao-confirm-leave')
@Component({
  selector: 'ecp-oao-confirm-leave',
  templateUrl: './confirm-leave.component.html',
  standalone: false
})
export class ConfirmLeaveComponent {
  constructor(private userService: UserService) {}

  public continueClicked(isStay = false): void {
    // Below subject passes the user response(stay/leave) to router guard canDeactivate
    // Based on below response user will be navigated to next page / stay on same page
    this.userService.confirmToLeaveSub.next(isStay);
  }
}
